// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"I2-z","colorTextValue":"J2-z","swatches":"K2-z","collapseLink":"L2-z","isCollapsed":"M2-z","dropdown":"N2-z","disabled":"O2-z"};